import { useState } from "react";
import DatePickerField from "../../components/common/DatePickerField";

export default function EmployeeForm({ onSubmit, loading }) {

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    date_of_joining: "",
    annual_ctc: ""
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      onSubmit(form);

      // optional reset
      setForm({
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        date_of_joining: "",
        annual_ctc: ""
      });

    } catch (err) {
      setError(err.message);
    }
  };

  return (

  <div className="w-full min-h-screen bg-gray-100">

    <div className="w-full bg-white shadow-sm p-8">

      {/* Header */}
      <div className="mb-6 border-b pb-4">
        <h2 className="text-3xl font-bold text-gray-800">
          Create Employee
        </h2>

        <p className="text-sm text-gray-500 mt-1">
          Enter employee details to create new employee
        </p>
      </div>

      {/* Error */}
      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
          {error}
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          <div>
            <label className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              required
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              required
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Mobile
            </label>
            <input
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              required
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <DatePickerField
            label="Date of Joining"
            required
            value={form.date_of_joining}
            onChange={(date) => setForm((prev) => ({ ...prev, date_of_joining: date }))}
          />

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Annual CTC
            </label>
            <input
              type="number"
              name="annual_ctc"
              value={form.annual_ctc}
              onChange={handleChange}
              required
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={loading}
            className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded-lg transition disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save Employee"}
          </button>
        </div>

      </form>

    </div>
  </div>
);
}